import type { Internship } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

const EXCLUDED_KEYS = new Set(['cover_media_url', 'logo_link']);

export const useAgentContext = (internship?: Internship) => {
  useRegisterAgentContext(
    internship
      ? {
          kind: 'entity',
          description: 'The internship/job opportunity the user is viewing',
          data: Object.fromEntries(
            Object.entries(internship).filter(([k]) => !EXCLUDED_KEYS.has(k)),
          ),
        }
      : null,
  );
};
